module.exports = __webpack_public_path__ + "static/Starbucks-688e183d3fe022fb2a9f0a9ac7410d44.svg";